import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import { getRoleComponent } from "services/RolesService";

const TagGeneralAttributes = ({
  attributes,
  tagId,
  tagProperties,
  handleTagPropChange,
  readOnly,
}) => {
  return (
    <Grid container xs={12} spacing={1}>
      {Object.entries(attributes ?? {}).map(([attr, metadata], idx) => (
        <Grid key={attr} xs={12} md={6} lg={4}>
          <FormControl variant="standard" fullWidth={true}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <TextField
                  variant="standard"
                  label={metadata.label || attr}
                  fullWidth
                  type={
                    metadata.type === "string" || metadata.type === "number"
                      ? metadata.type
                      : "string"
                  }
                  value={
                    attr
                      .split(".")
                      .reduce((o, i) => o[i] || "", tagProperties) ||
                    metadata.defaultValue ||
                    ""
                  }
                  InputLabelProps={{ sx: { fontSize: 12 } }}
                  InputProps={{ sx: { fontSize: 12 } }}
                  onChange={(event) =>
                    handleTagPropChange(tagId, attr, event.target.value)
                  }
                  disabled={readOnly || metadata.editable === false}
                />
              </div>
            </div>
          </FormControl>
        </Grid>
      ))}
    </Grid>
  );
};

const TagRoleProperties = ({
  tagId,
  tagProperties,
  role,
  handleTagPropChange,
  handleTagPropsChange,
  readOnly,
}) => {
  const TagRoleBespokeComponent = getRoleComponent(role.guuid);
  return TagRoleBespokeComponent ? (
    <TagRoleBespokeComponent
      tagId={tagId}
      tagProperties={tagProperties}
      handleTagPropChange={handleTagPropChange}
      handleTagPropsChange={handleTagPropsChange}
      readOnly={readOnly}
    />
  ) : (
    <TagGeneralAttributes
      attributes={role.attributes}
      tagId={tagId}
      tagProperties={tagProperties}
      handleTagPropChange={handleTagPropChange}
      readOnly={readOnly}
    />
  );
};

export default TagRoleProperties;
export { TagGeneralAttributes };
